__turbopack_context__.v({
  "overlay": "style-module-scss-module__fSrD6a__overlay",
  "videoBackground": "style-module-scss-module__fSrD6a__videoBackground",
  "videoWrapper": "style-module-scss-module__fSrD6a__videoWrapper",
});
